import React, { useContext } from 'react'
import './projects.css'
import giza from "./img/giza.png"
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import './projects.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReact, faGithub, faFigma, faHtml5, faCss3, faJsSquare } from '@fortawesome/free-brands-svg-icons';
import { faLink } from '@fortawesome/free-solid-svg-icons';
import tailwind from './img/tailwind.png'
import ecommerce from './img/samuelstore.png'
import shopify from './img/shopify.png'
import solidity from './img/solidity.png'
import linkwarden from './img/linkwarden.png'
import gcp from './img/gclogo.png'
import { ThemeContext } from './context/ThemeContext';


const Projects = () => {

    const { darkMode } = useContext(ThemeContext);


    return (
        <div className='lg:mx-12 mx-3 py-20' id='works'>

            <h1 className='text-3xl text-center mb-10'>What I've Made</h1>

            <div className='flex items-center justify-center gap-5 flex-wrap'>
                <Card sx={{
                    maxWidth: 345, minHeight: 450, borderRadius: 3, '&:hover': {
                        boxShadow: 5,
                    },
                }}>
                    <CardMedia
                        component="img"
                        height="200"
                        image="/oja-local.png"
                        alt="Oja-Local"
                    />
                    <CardContent>
                        <div className='text-xl'>
                            Oja-Local
                        </div>
                        <div>
                            Cloud-native web app. Deployable on Cloud Run and Kubernetes Engine. Next.js, Firebase, Cloud SQL and Cloud Storage and other GCP services
                        </div>
                        <div className='flex flex-row items-center gap-3 mt-3'>
                            <div className='flex items-center gap-1'>
                                <a href='https://oja-local-790874300827.europe-west1.run.app' target='_blank' rel="noreferrer" className='cool-link'>Live</a>
                                <FontAwesomeIcon icon={faLink} />
                            </div>

                            <div className='flex items-center  gap-1'>
                                <a href='https://github.com/samuelajayii/oja-local' target='_blank' rel="noreferrer" className='cool-link'>Github</a>
                                <FontAwesomeIcon icon={faGithub} />
                            </div>

                        </div>
                        <div className='my-2'>Stack Used:</div>
                        <div className='flex flex-wrap items-center gap-2'>
                            <div className='flex items-center gap-2 rounded-full border w-fit border-black  px-2'>
                                <h1>Next.js</h1>
                                <img src='/next2.png' alt='next-logo' className='w-6' />
                            </div>
                            <div className='flex items-center gap-2 rounded-full border w-fit border-black  px-2'>
                                <h1>TailwindCSS</h1>
                                <img src={tailwind} alt='tailwind-log' className='w-6' />
                            </div>
                            <div className='flex items-center gap-2 rounded-full border w-fit border-black  px-2'>
                                <h1>Google Cloud</h1>
                                <img src={gcp} alt='tailwind-log' className='w-6' />
                            </div>
                        </div>
                    </CardContent>

                </Card>

                <Card sx={{
                    maxWidth: 345, minHeight: 450, borderRadius: 3, '&:hover': {
                        boxShadow: 5,
                    },
                }}>
                    <CardMedia
                        component="img"
                        height="200"
                        image="/travelogue.png"
                        alt="Travelogue"
                    />
                    <CardContent>
                        <div className='text-xl'>
                            Travelogue
                        </div>
                        <div>
                            Travel blog web app made with Next.js, Tailwind, Sanity CMS, containerised and deployed on Google Cloud Run.
                        </div>
                        <div className='flex flex-row items-center gap-3 mt-3'>
                            <div className='flex items-center gap-1'>
                                <a href='https://travelogue-963995938119.europe-west1.run.app/' target='_blank' rel="noreferrer" className='cool-link'>Live</a>
                                <FontAwesomeIcon icon={faLink} />
                            </div>

                            <div className='flex items-center  gap-1'>
                                <a href='https://github.com/samuelajayii/travelogue' target='_blank' rel="noreferrer" className='cool-link'>Github</a>
                                <FontAwesomeIcon icon={faGithub} />
                            </div>

                        </div>
                        <div className='my-2'>Stack Used:</div>
                        <div className='flex flex-wrap items-center gap-2'>
                            <div className='flex items-center gap-2 rounded-full border w-fit border-black  px-2'>
                                <h1>Next.js</h1>
                                <img src='/next2.png' alt='next-logo' className='w-6' />
                            </div>
                            <div className='flex items-center gap-2 rounded-full border w-fit border-black  px-2'>
                                <h1>TailwindCSS</h1>
                                <img src={tailwind} alt='tailwind-log' className='w-6' />
                            </div>
                            <div className='flex items-center gap-2 rounded-full border w-fit border-black  px-2'>
                                <h1>Sanity</h1>
                                <img src='/sanity.png' alt='sanity-logo' className='w-6' />
                            </div>
                            <div className='flex items-center gap-2 rounded-full border w-fit border-black  px-2'>
                                <h1>Google Cloud</h1>
                                <img src={gcp} alt='tailwind-log' className='w-6' />
                            </div>
                        </div>
                    </CardContent>

                </Card>

                <Card sx={{
                    maxWidth: 345, minHeight: 450, borderRadius: 3, '&:hover': {
                        boxShadow: 5,
                    }
                }}>
                    <CardMedia
                        component="img"
                        height="200"
                        image="/lottery.png"
                        alt="Lottery"
                    />
                    <CardContent>
                        <div className='text-xl'>
                            Smart Contrat Lottery
                        </div>
                        <div>
                            Smart Contract Lottery Frontend, made with React, Tailwind Web3.js and Solidity. Deployed on the sepolia testnet
                        </div>
                        <div className='flex flex-row items-center gap-3 mt-3'>
                            <div className='flex items-center gap-1'>
                                <a href='https://innovators-lottery.netlify.app/' target='_blank' rel="noreferrer" className='cool-link'>Live</a>
                                <FontAwesomeIcon icon={faLink} />
                            </div>

                            <div className='flex items-center  gap-1'>
                                <a href='https://github.com/samuelajayii/lottery-smart-contract-frontend' target='_blank' rel="noreferrer" className='cool-link'>Github</a>
                                <FontAwesomeIcon icon={faGithub} />
                            </div>

                        </div>
                        <div className='my-2'>Stack Used:</div>
                        <div className='flex items-center gap-2 flex-wrap'>
                            <div className='flex items-center gap-2 rounded-full border w-fit border-black  px-2'>
                                <h1>React.js</h1>
                                <FontAwesomeIcon icon={faReact} />
                            </div>
                            <div className='flex items-center gap-2 rounded-full border w-fit border-black  px-2'>
                                <h1>TailwindCSS</h1>
                                <img src={tailwind} alt='tailwind-log' className='w-5' />
                            </div>
                            <div className='flex items-center gap-2 rounded-full border w-fit border-black  px-2'>
                                <h1>Web3.js</h1>
                                <img src='/web3js.png' alt='sanity-logo' className='w-6' />
                            </div>
                            <div className='flex items-center gap-2 rounded-full border w-fit border-black  px-2'>
                                <h1>Solidity</h1>
                                <img src={solidity} alt='sanity-logo' className='w-4 h-4' />
                            </div>
                        </div>
                    </CardContent>

                </Card>
                <Card sx={{
                    maxWidth: 345, minHeight: 450, borderRadius: 3,
                    '&:hover': {
                        boxShadow: 5,
                    },
                }}>
                    <CardMedia
                        component="img"
                        height="200"
                        image={ecommerce}
                        alt="E-Commerce"
                    />
                    <CardContent>
                        <div className='text-xl'>
                            E-Commerce
                        </div>
                        <div>
                            E-commerce website built with React and the Fakestore API
                        </div>
                        <div className='flex flex-row items-center gap-3 mt-3'>
                            <div className='flex items-center gap-1'>
                                <a href='https://samuelstore.netlify.app/' target='_blank' rel="noreferrer" className='cool-link'>Live</a>
                                <FontAwesomeIcon icon={faLink} />
                            </div>

                            <div className='flex items-center  gap-1'>
                                <a href='https://github.com/samuelajayii/e-commerce' target='_blank' rel="noreferrer" className='cool-link'>Github</a>
                                <FontAwesomeIcon icon={faGithub} />
                            </div>
                        </div>
                        <div className='my-2'>Stack Used:</div>
                        <div className='flex items-center gap-2'>
                            <div className='flex items-center gap-2 rounded-full border w-fit border-black  px-2'>
                                <h1>React</h1>
                                <FontAwesomeIcon icon={faReact} />
                            </div>
                            <div className='flex items-center gap-2 rounded-full border w-fit border-black  px-2'>
                                <h1>TailwindCSS</h1>
                                <img src={tailwind} alt='tailwind-log' className='w-6' />
                            </div>
                        </div>
                    </CardContent>

                </Card>
                <Card sx={{
                    maxWidth: 345, minHeight: 450, borderRadius: 3, '&:hover': {
                        boxShadow: 5,
                    },
                }}>
                    <CardMedia
                        component="img"
                        height="200"
                        image={giza}
                        alt="Giza-Landing-Page"
                    />
                    <CardContent>
                        <div className='text-xl'>
                            Giza Landing Page
                        </div>
                        <div>
                            Landing page for the giza shopping website
                        </div>
                        <div className='flex flex-row items-center gap-3 mt-3'>
                            <div className='flex items-center gap-1'>
                                <a href='https://giza-landing-page.netlify.app/' target='_blank' rel="noreferrer" className='cool-link'>Live</a>
                                <FontAwesomeIcon icon={faLink} />
                            </div>

                            <div className='flex items-center  gap-1'>
                                <a href='https://github.com/samuelajayii/giza-landing-page' target='_blank' rel="noreferrer" className='cool-link'>Github</a>
                                <FontAwesomeIcon icon={faGithub} />
                            </div>
                            <div className='flex items-center  gap-1'>
                                <a href='https://www.figma.com/design/OF7NwjIuu9Mm48OeJyGheF/GIZA?node-id=0-1&t=z5kqAvA3JvZFC5LG-0' target='_blank' rel="noreferrer" className='cool-link'>Figma</a>
                                <FontAwesomeIcon icon={faFigma} />
                            </div>
                        </div>
                        <div className='my-2'>Stack Used:</div>
                        <div className='flex items-center gap-2'>
                            <div className='flex items-center gap-2 rounded-full border w-fit border-black  px-2'>
                                <h1>React</h1>
                                <FontAwesomeIcon icon={faReact} />
                            </div>
                            <div className='flex items-center gap-2 rounded-full border w-fit border-black  px-2'>
                                <h1>TailwindCSS</h1>
                                <img src={tailwind} alt='tailwind-log' className='w-6' />
                            </div>
                        </div>
                    </CardContent>

                </Card>
                <Card sx={{
                    maxWidth: 345, minHeight: 450, borderRadius: 3, '&:hover': {
                        boxShadow: 5,
                    },
                }}>
                    <CardMedia
                        component="img"
                        height="200"
                        image={shopify}
                        alt="shopify"
                    />
                    <CardContent>
                        <div className='text-xl'>
                            Shopify Dashboard
                        </div>
                        <div>
                            Shopify dashboard built for a Frantz Kati Hackerthon
                        </div>
                        <div className='flex flex-row items-center gap-3 mt-3'>
                            <div className='flex items-center gap-1'>
                                <a href='https://samshopify.netlify.app/' target='_blank' rel="noreferrer" className='cool-link'>Live</a>
                                <FontAwesomeIcon icon={faLink} />
                            </div>

                            <div className='flex items-center  gap-1'>
                                <a href='https://github.com/samuelajayii/shopfiy-dashboard' target='_blank' rel="noreferrer" className='cool-link'>Github</a>
                                <FontAwesomeIcon icon={faGithub} />
                            </div>
                        </div>
                        <div className='my-2'>Stack Used:</div>
                        <div className='flex items-center gap-2'>
                            <div className='flex items-center gap-2 rounded-full border w-fit border-black  px-2'>
                                <h1>HTML</h1>
                                <FontAwesomeIcon icon={faHtml5} />
                            </div>
                            <div className='flex items-center gap-2 rounded-full border w-fit border-black  px-2'>
                                <h1>CSS</h1>
                                <FontAwesomeIcon icon={faCss3} />
                            </div>
                            <div className='flex items-center gap-2 rounded-full border w-fit border-black  px-2'>
                                <h1>Javascript</h1>
                                <FontAwesomeIcon icon={faJsSquare} />
                            </div>

                        </div>
                    </CardContent>

                </Card>
                <Card sx={{
                    maxWidth: 345, minHeight: 450, borderRadius: 3, '&:hover': {
                        boxShadow: 5,
                    },
                }}>
                    <CardMedia
                        component="img"
                        height="200"
                        image={linkwarden}
                        alt="linkwarden"
                    />
                    <CardContent>
                        <div className='text-xl'>
                            Linkwarden
                        </div>
                        <div>
                            Linkwarden website, developed from a figma file
                        </div>
                        <div className='flex flex-row items-center gap-3 mt-3'>
                            <div className='flex items-center gap-1'>
                                <a href='https://linkwarden-twitter.netlify.app/' target='_blank' rel="noreferrer" className='cool-link'>Live</a>
                                <FontAwesomeIcon icon={faLink} />
                            </div>

                            <div className='flex items-center  gap-1'>
                                <a href='https://github.com/samuelajayii/linkwarden-twitter' target='_blank' rel="noreferrer" className='cool-link'>Github</a>
                                <FontAwesomeIcon icon={faGithub} />
                            </div>
                            <div className='flex items-center  gap-1'>
                                <a href='https://www.figma.com/file/CWFE222KgPWIM171dc3iBd/Linkwarden-Twitter?type=design&node-id=1-2&mode=design' target='_blank' rel="noreferrer" className='cool-link'>Figma</a>
                                <FontAwesomeIcon icon={faFigma} />
                            </div>
                        </div>
                        <div className='my-2'>Stack Used:</div>
                        <div className='flex items-center gap-2'>
                            <div className='flex items-center gap-2 rounded-full border w-fit border-black  px-2'>
                                <h1>React</h1>
                                <FontAwesomeIcon icon={faReact} />
                            </div>
                            <div className='flex items-center gap-2 rounded-full border w-fit border-black  px-2'>
                                <h1>TailwindCSS</h1>
                                <img src={tailwind} alt='tailwind-log' className='w-6' />
                            </div>
                        </div>
                    </CardContent>

                </Card>
            </div>

            <h1 className='text-3xl text-center my-14'>Head over to my <a href='https://github.com/samuelajayii' target='_blank' rel="noreferrer" className={darkMode ? "cool-link-black italic sm:underline lg:no-underline" : "cool-link italic sm:underline lg:no-underline"}
            >github</a> and check out for more projects; both web2 and solidity</h1>

        </div>

    )
}

export default Projects
